import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { filePdfIcon, searchIcon } from '@progress/kendo-svg-icons';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { DateRangeSearchModel } from 'app/models/date-range-search.model';
import { GroupModel } from 'app/models/group.model';
import { InvoicesModel } from 'app/models/invoices.model';
import { ProviderBillChargeModel } from 'app/models/provider-bill-charge.model';
import { ConfigService } from 'app/services/config.service';
import { GroupService } from 'app/services/group.service';
import { ProviderBillService } from 'app/services/provider-bill.service';
import { UtilityService } from 'app/services/utility.service';
import {saveAs} from 'file-saver';
import moment from 'moment';

interface Item {
  text: string,
  value: number
}

@Component({
  selector: 'app-group-utility-bills',
  standalone: false,
  templateUrl: './group-utility-bills.component.html',
  styleUrl: './group-utility-bills.component.scss'
})
export class GroupUtilityBillsComponent extends NexusComponent {
  public group_model: GroupModel;
  public provider_bill_charges_model: Array<ProviderBillChargeModel> = new Array<ProviderBillChargeModel>();

  public billing_period_date: Date;
  public bills_start_date: Date;
  public bills_end_date: Date;
  public bills_filter_collapsed = false;
  public bills_error: string;
  searchIcon=searchIcon
  filePdfIcon=filePdfIcon
  public faLongArrowAltRight = faLongArrowAltRight;

  public months: Array<Item> = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 }
  ];

  public bills_form = new UntypedFormGroup({
    start_month: this.CreateRequiredFormControl(),
    start_year: this.CreateRequiredFormControl(),
    end_month: this.CreateRequiredFormControl(),
    end_year: this.CreateRequiredFormControl()
  });

  constructor(protected route: ActivatedRoute, private config: ConfigService, private group_service: GroupService, private provider_bill_service: ProviderBillService, private utility_service: UtilityService) {
   super();
   this.setFormData();
  }

  ngOnInit() {
    this.route.parent.data.subscribe(({ group_model }) => {
      this.group_model = group_model;
    });

    // this.route.data.subscribe(({ provider_bill_portions_model }) => {
    //   this.provider_bill_portions_model = provider_bill_portions_model;
    // });

  }

  private setFormData() {
      this.billing_period_date = moment([this.config.getCurrentMoment().year(), this.config.getCurrentMoment().month(), 1]).toDate();
      
      this.bills_start_date = moment([this.billing_period_date.getFullYear(), this.billing_period_date.getMonth(), 1]).toDate();
      this.bills_end_date = moment([this.billing_period_date.getFullYear(), this.billing_period_date.getMonth(), 1]).toDate();

      this.bills_form.get('start_month').patchValue(this.bills_start_date.getMonth() + 1);
      this.bills_form.get('start_year').patchValue(this.bills_start_date.getFullYear());
      this.bills_form.get('end_month').patchValue(this.bills_start_date.getMonth() + 1);
      this.bills_form.get('end_year').patchValue(this.bills_start_date.getFullYear());
  }

  billsSubmit() {
      let model: DateRangeSearchModel = new DateRangeSearchModel();

      this.bills_start_date = moment([this.bills_form.get('start_year').value, this.bills_form.get('start_month').value - 1, 1]).toDate();
      this.bills_end_date = moment([this.bills_form.get('end_year').value, this.bills_form.get('end_month').value, 1]).toDate();

      model.start_date = this.bills_start_date;
      model.end_date = this.bills_end_date;

      this.bills_start_date = moment([this.bills_form.get('start_year').value, this.bills_form.get('start_month').value - 1, 1]).toDate();
      this.bills_end_date = moment([this.bills_form.get('end_year').value, this.bills_form.get('end_month').value - 1, 1]).toDate();
      
      this.StartSpinner();
      this.group_service.GetGroupUtilityBills(this.group_model.id, model).subscribe(
        data => {
          this.provider_bill_charges_model = data;
          data.forEach(b => {
            (b as any).consumption_display = b.consumption != null
              ? `${b.consumption.toLocaleString('en-US', { maximumFractionDigits: 2 })} ${b.usage_unit?.name ?? ''}`.trim() || null
              : null;
          });
          this.StopSpinner();
        },
        err => {
          this.StopSpinner();
        });
    }


      exportBill(item: ProviderBillChargeModel) {
        this.StartSpinner();
        if (item.provider_bill.source_type == "MeterConversion") {
          this.provider_bill_service.GetProviderBillPDF(item.provider_bill_id).subscribe(
            file_model => {
              saveAs(file_model.url, file_model.file_name);
              this.StopSpinner();
            },
            error => {
              this.StopSpinner();
            });
        }
        else {
          if(item.provider_bill_charge_file_id && item.provider_bill_charge_file?.file)
          {
            if (item.provider_bill_charge_file.file) {
              this.utility_service.DownloadExport(item.provider_bill_charge_file.file).subscribe(
                data => {
                  saveAs(data, item.provider_bill_charge_file.file.file_name);
                  this.StopSpinner();
                },
                err => {
                  this.StopSpinner();
                });
            }
          }
          else
          {
            this.group_service.CreateExport(item).subscribe(
              export_data => {
                if (export_data.file) {
                  this.utility_service.DownloadExport(export_data.file).subscribe(
                    data => {
                      saveAs(data, export_data.file.file_name);
                      this.StopSpinner();
                    },
                    err => {
                      this.StopSpinner();
                    });
                }
                else {
                  this.StopSpinner();
                }
              },
              err => {
                this.StopSpinner();
              });
            }
          }
      }
}
